// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"450":"About","653":"Projects","994":"Project"}[chunkId] + "." + {"450":"5950321b","653":"02606c1a","994":"1653868e"}[chunkId] + ".js";
};